module.exports = __webpack_public_path__ + "img/partner_logo_for_sp.055c675.png";